
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";
const authStore = namespace("auth");
import CardRh from "@/components/cards/ManzaCard.vue";
import DispensaMedicaService from "@/service/v1/sigap/DispensaMedicaService";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import Multiselect from "@vueform/multiselect";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Cadastro from "./_Cadastro.vue";
import Editar from "./_Editar.vue";
import { Prop } from "vue-property-decorator";
import $ from "jquery";

@Options({
    name: "MatriculaDispensaMedica",
    components: { CardRh, KDataTable, Multiselect, Cadastro, Editar },
})
export default class MatriculaDispensaMedica extends Vue {
    @Prop() readonly matricula!: any;

    @authStore.Getter
    public perfis!: any;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service = new DispensaMedicaService();
    public dados: any = null;

    public status_id: any = null;
    public matriculaId: any = null;
    public status: any = null;
    public search = "";
    public modal_cadastro = "kt_cadatrar_matricula_dispensa_medica";
    public modal_atualizar = "kt_atualizar_matricula_dispensa_medica";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.status_id = null;
        this.refreshTable();
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    created() {
        this.matriculaId = this.$route.params.id;
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.getStatus();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    status: this.status_id,
                    matriculaId: this.matriculaId,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.order = [[0, 'desc']];
        this.config.columns = [
            { data: "inicio", name: "inicio" },
            { data: "fim", name: "fim" },
            { data: "status", name: "status" },
            { data: "createdAt", name: "createdat" },
            { data: "updatedAt", name: "updatedat" },
        ];

        this.config.columnDefs = [
            {
                targets: 0,
                render: (row) => {
                    return SiteUtils.formatData(row);
                }
            },
            {
                targets: 1,
                render: (row) => {
                    return SiteUtils.formatData(row);
                }
            },
            {
                targets: 2,
                render: (row) => {
                    return row.nome ? row.nome.replaceAll("_", " ") : "";
                }
            },
            {
                targets: 3,
                render: (row) => {
                    return SiteUtils.formatDataHora(row);
                }
            },
            {
                targets: 4,
                render: (row) => {
                    return SiteUtils.formatDataHora(row);
                }
            },
        ];

        if (this.hasPermissaoEditar && this.matricula.status.id != 6) {
            this.config.columns.push({ data: "id", name: "id", orderable: false, searchable: false });
            this.config.columnDefs.push({
                targets: 5,
                render: (row, type, val) => {
                    let buttom = "";
                    for (const key in val) {
                        buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                    }
                    return '<button class="btn btn-success btn-sm" btn-editar-dispensa-medica ' + buttom + ' data-bs-toggle="modal" data-bs-target="#' +
                        this.modal_atualizar + '"><i class="fa fa-edit"></i></button>';
                },
            });
        }
    }

    public tableatualizada() {
        $("[btn-editar-dispensa-medica]").click((btn) => {
            this.dados = null;
            setTimeout(() => {
                this.dados = $(btn.currentTarget).data();
            }, 10);
        });
    }
}
